/**
 * Created by stanislavk on 20/07/2017.
 */

import { Injectable } from "@angular/core";
import * as _ from "lodash";
import * as moment from "moment";

@Injectable({ providedIn: 'root' })
  export class DateService {
	/**
	 * Searches for date values in the object and converts them to format without time.
	 * @param data
	 */
	public removeTimeFromDate(data: any[]) {
		data.forEach((element) => {
			let keys = Object.keys(element);
			for (let i = 0; i < keys.length; i++) {
				if (_.isDate(element[keys[i]])) {
					element[keys[i]] = moment(element[keys[i]]).startOf('day').toDate();
				} else if (_.isArray(element[keys[i]])) {
					this.removeTimeFromDate(element[keys[i]]);
				}
			}
		});
	}

	/**
	 * Returns true is the given date is falls in the time range of the past {numOfPastDays} days
	 * @param {Date} date - the date to check
	 * @param {number} numOfPastDays - the number of past days range
	 */
	public isDateInPastDaysRange(date: Date, numOfPastDays: number) {
		return this.isDateInDaysRange(date, numOfPastDays, 0);
	}

	/**
	 * Returns true is the given date is falls in the time range of the past {numOfPastDays} days
	 * and {numOfFutureDays} future days
	 * @param {Date} date - the date to check
	 * @param {number} numOfPastDays - the number of past days range
	 * @param {number} numOfFutureDays - the number of future days range
	 */
	public isDateInDaysRange(date: Date, numOfPastDays: number, numOfFutureDays: number) {
		let daysDiff = moment(new Date()).diff(date, 'days');
		return daysDiff >= -numOfFutureDays && daysDiff <= numOfPastDays;
	}

	/**
	 * Returns true is the given date is falls strictly(not inclusive)  in the time range of the past {numOfPastDays} days
	 * and {numOfFutureDays} future days
	 * @param {Date} date - the date to check
	 * @param {number} numOfPastDays - the number of past days range
	 * @param {number} numOfFutureDays - the number of future days range
	 */
	public isDateInDaysStrictRange(date: Date, numOfPastDays: number, numOfFutureDays: number) {
		let daysDiff = moment(new Date()).diff(date, 'days');
		return daysDiff > -numOfFutureDays && daysDiff < numOfPastDays;
	}

	/**
	 * Returns true is the given date is greater than {numOfFutureDays} from today
	 * @param {Date} date - the date to check
	 * @param {number} numOfFutureDays - the number of future days range
	 */
	public isDateAfterFutureDays(date: Date, numOfFutureDays: number) {
		let daysDiff = moment(date).diff(new Date(), 'days');
		return daysDiff >= numOfFutureDays;
	}

	/**
	 * Returns true is the given date is today
	 * @param {Date} date - the date to check
	 */
	public isToday(date: Date): boolean {
		return moment().isSame(date,'days');
		//return moment().diff(date, 'days') === 0;
	}

	/**
	 * Returns true is the given date is tomorrow
	 * @param {Date} date - the date to check
	 */
	public isTomorrow(date: Date): boolean {
		return moment().add(1,'days').isSame(date,'days');
		//return moment().diff(date, 'days') === -1;
	}

	/**
	 * Returns true is the given date is yesterday
	 * @param {Date} date - the date to check
	 */
	public isYesterday(date: Date): boolean {
		return moment().add(-1,'days').isSame(date,'days');
	}

}
